
<div class="schedules">
  <schedule-badge
    v-for="(s, i) in schedules"
    :key="i"
    :schedule="typeof s == `string` ? s : s.name"
    v-on:click="$emit('click', typeof s === 'string' ? s : s.name)"
  ></schedule-badge>
</div>
